const ITEMS = [
  "Kritajna Ventures LLP",
  "Grounded in Value",
  "Built for Scale",
  "Software",
  "Real Estate",
  "Global Commerce",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap uppercase tracking-[0.32em] text-sm sm:text-base font-semibold px-8 ${
            i % 2 === 0 ? "font-display normal-case tracking-[0.08em] text-xl sm:text-2xl text-navy/80" : "text-peri"
          }`}
        >
          {item}
        </span>
        <img src="/assets/lotus-icon.png" alt="" aria-hidden="true" className="w-7 h-7 object-contain" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="relative bg-mist border-y border-navy/10 py-7 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </section>
);

export default Marquee;
